// Máscara de data digitada: mantém apenas dígitos e insere as barras conforme o usuário digita.
// Aceita os dois formatos usados nos formulários: DD/MM/AA e DD/MM/AAAA.
export const aplicarMascaraData = (valor) => {
  const digitos = String(valor ?? '').replace(/\D/g, '').slice(0, 8);
  if (digitos.length <= 2) return digitos;
  if (digitos.length <= 4) return `${digitos.slice(0, 2)}/${digitos.slice(2)}`;
  return `${digitos.slice(0, 2)}/${digitos.slice(2, 4)}/${digitos.slice(4)}`;
};

export default aplicarMascaraData;
